webpackJsonp([1],{

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(886),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 656:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identifyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_logrocket__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mixpanel_browser__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omit__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__posthog_client__ = __webpack_require__(180);







function identifyUser(userId) {
  __WEBPACK_IMPORTED_MODULE_2_mixpanel_browser__["a" /* default */].identify(userId);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__posthog_client__["b" /* identifyPosthogDistinctId */])(userId);
}

function setUserInfo(data) {
  __WEBPACK_IMPORTED_MODULE_2_mixpanel_browser__["a" /* default */].people.set({
    "$email": data.email,
    "$name": data.name,
    "$organization": data.orgName,
    "$role": data.role
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__posthog_client__["c" /* identifyPosthogWithPerson */])(data.id, {
    email: data.email,
    name: data.name,
    organization: data.orgName,
    role: data.role
  });
  gtag('set', 'user_properties', {
    organization: data.orgName,
    role: data.role,
    name: data.name
  });
  __WEBPACK_IMPORTED_MODULE_1_logrocket___default.a.identify(data.id, __WEBPACK_IMPORTED_MODULE_4_lodash_omit___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data), ['id']));
}

function trackEvent(event, props) {
  // If user is impersonated, do not track events
  if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].getters.impersonatedUserId) {
    return;
  }

  var defaultData = {
    isRunningFromApp: !!window.matchMedia('(display-mode: standalone)').matches
  };

  var payload = props ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, defaultData) : defaultData;

  __WEBPACK_IMPORTED_MODULE_2_mixpanel_browser__["a" /* default */].track(event, payload);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__posthog_client__["d" /* capturePosthog */])(event, payload);
}



/***/ }),

/***/ 682:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(177),
    baseOrderBy = __webpack_require__(865),
    baseRest = __webpack_require__(315),
    isIterateeCall = __webpack_require__(178);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isToolbarVisibleForRoute;
/**
 * Whether the app toolbar is shown for this route.
 * Keep in sync with Toolbar.vue (hideToolbarRoutes, setShow, $route watch).
 */
var HIDE_TOOLBAR_ROUTE_NAMES = ['Signin', 'PassRecovery', 'PassChange', 'DashboardLiag', 'LoadingScreen', 'Welcome', 'SharedPluviometricChart'];

function isToolbarVisibleForRoute(route) {
  if (!route) return false;
  var name = route.name;
  var path = route.path || '';
  var fullPath = route.fullPath || '';
  if (HIDE_TOOLBAR_ROUTE_NAMES.includes(name)) return false;
  if (path.includes('/r/')) return false;
  if (path === '/') return false;
  if (fullPath.includes('loading')) return false;
  return true;
}

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(850)
}
var Component = __webpack_require__(39)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(888),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 844:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_firebase__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sortBy__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      textFieldActive: false,
      items: [],
      userSelected: undefined,
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.$store.getters.impersonatedUserId) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return _this.activateImpersonate();

            case 3:
              _this.userSelected = _this.$store.getters.impersonatedUserId;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    canImpersonate: function canImpersonate() {
      var user = this.$store.getters.user;
      return this.$store.getters.impersonatedUserId || user && user.isAdmin;
    }
  },
  methods: {
    activateImpersonate: function activateImpersonate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var db, organizations, orgsCollection, users, usersCollection;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(_this2.items.length === 0)) {
                  _context2.next = 17;
                  break;
                }

                _this2.loading = true;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__plugins_firebase__["a" /* firestore */];

              case 5:
                db = _context2.sent;
                organizations = {};
                _context2.next = 9;
                return db.collection('app/v1/organizations').get();

              case 9:
                orgsCollection = _context2.sent;

                orgsCollection.forEach(function (org) {
                  organizations[org.id] = org.data().name;
                });

                users = [];
                _context2.next = 14;
                return db.collection('app/v1/users').orderBy('organization').get();

              case 14:
                usersCollection = _context2.sent;

                usersCollection.forEach(function (userDoc) {
                  var user = userDoc.data();
                  // Skip users without organization (deleted/unlinked users)
                  if (!user.organization) {
                    return;
                  }
                  var orgId = user.organization.id;
                  users.push({ id: userDoc.id, label: (organizations[orgId] || orgId) + ': ' + user.name + ' ' + (user.lastName || '') + ' | Email: ' + user.email + ' | Phone: ' + user.phone + ' | ID: ' + userDoc.id });
                });

                _this2.items = __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy___default()(users, function (user) {
                  return user.label.toLowerCase();
                });

              case 17:

                _this2.textFieldActive = true;
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](0);

                _this2.$root.snack.show({ text: _this2.$t('UI.serverError'), error: true });
                console.error('IMPERSONATE_ERROR:', _context2.t0);

              case 24:
                _context2.prev = 24;

                _this2.loading = false;
                return _context2.finish(24);

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 20, 24, 27]]);
      }))();
    },
    impersonate: function impersonate(impersonatedUserId) {
      this.$store.commit('setImpersonatedUserId', impersonatedUserId || null);
      if (!impersonatedUserId) {
        this.$store.commit('setUser', {});
      }
      location.reload();
    }
  },
  watch: {
    userSelected: function userSelected(val) {
      if (val !== this.$store.getters.impersonatedUserId) {
        this.impersonate(val);
      }
    }
  }
});

/***/ }),

/***/ 846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_helpers__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toolbarVisibility__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImpersonateBtn_vue__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImpersonateBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ImpersonateBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_track_events__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_const__ = __webpack_require__(301);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      transparentToolbar: false,
      transparentToolbarRoutes: ['/addDevice', '/addUser', '/addCrop'],
      show: false,
      searchText: '',
      dialMenu: false
    };
  },
  created: function created() {
    this.show = this.setShow();
  },

  components: {
    ImpersonateBtn: __WEBPACK_IMPORTED_MODULE_2__ImpersonateBtn_vue___default.a
  },
  methods: {
    setShow: function setShow() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_toolbarVisibility__["a" /* isToolbarVisibleForRoute */])(this.$router.currentRoute);
    },
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/signin');
    },
    toggleMenu: function toggleMenu(isMenuOpened) {
      if (isMenuOpened) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["a" /* trackEvent */])(__WEBPACK_IMPORTED_MODULE_4__constants_const__["a" /* EVENTS_TO_TRACK */].CLICK_CLOSE_MENU_BUTTON);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["a" /* trackEvent */])(__WEBPACK_IMPORTED_MODULE_4__constants_const__["a" /* EVENTS_TO_TRACK */].CLICK_OPEN_MENU_BUTTON);
      }
    },
    clickOrganizationHomeBtn: function clickOrganizationHomeBtn() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["a" /* trackEvent */])(__WEBPACK_IMPORTED_MODULE_4__constants_const__["a" /* EVENTS_TO_TRACK */].CLICK_ORGANIZATION_HOME_VIEW_BUTTON);
      this.$router.push('/organizationHome');
    },
    clickReportsBtn: function clickReportsBtn() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["a" /* trackEvent */])(__WEBPACK_IMPORTED_MODULE_4__constants_const__["a" /* EVENTS_TO_TRACK */].CLICK_REPORTS_VIEW_BUTTON);
      this.$router.push('/reports');
    },
    clickAuditsBtn: function clickAuditsBtn() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_track_events__["a" /* trackEvent */])(__WEBPACK_IMPORTED_MODULE_4__constants_const__["a" /* EVENTS_TO_TRACK */].CLICK_AUDITS_VIEW_BUTTON);
      this.$router.push('/audits');
    }
  },
  computed: {
    userProfilePic: function userProfilePic() {
      if (this.$store.getters.user && this.$store.getters.user.photoUrl) {
        return this.$store.getters.user.profilePic;
      }
      if (this.$store.getters.user.roles) {
        if (this.$store.getters.user.isAdmin || this.$store.getters.user.roles.owner) {
          return __webpack_require__(176);
        } else if (this.$store.getters.user.roles.manager) {
          return __webpack_require__(310);
        } else if (this.$store.getters.user.roles.fieldman) {
          return __webpack_require__(309);
        } else if (this.$store.getters.user.roles.farmhand) {
          return __webpack_require__(308);
        }
      }
      return __webpack_require__(308);
    },
    isUserAuthToCrud: function isUserAuthToCrud() {
      var user = this.$store.getters.user;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_helpers__["h" /* isAuthToEdit */])(user, this.$store.getters.impersonatedUserId);
    },
    isUserAuthToReports: function isUserAuthToReports() {
      var user = this.$store.getters.user;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_helpers__["i" /* isAuthToReports */])(user, this.$store.getters.impersonatedUserId);
    },
    isUserAuthToAudits: function isUserAuthToAudits() {
      var user = this.$store.getters.user;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_helpers__["j" /* isAuthToAudits */])(user, this.$store.getters.impersonatedUserId);
    }
  },
  watch: {
    '$route': function $route(to) {
      this.show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_toolbarVisibility__["a" /* isToolbarVisibleForRoute */])(to);
      if (this.transparentToolbarRoutes.includes(to.fullPath)) {
        this.transparentToolbar = true;
      } else {
        this.transparentToolbar = false;
      }
    }
  }
});

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(625)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImpersonateBtn.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(848);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(626)("6cf3e77f", content, true, {});

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(86),
    baseGet = __webpack_require__(88),
    baseIteratee = __webpack_require__(40),
    baseMap = __webpack_require__(323),
    baseSortBy = __webpack_require__(866),
    baseUnary = __webpack_require__(115),
    compareMultiple = __webpack_require__(868),
    identity = __webpack_require__(89),
    isArray = __webpack_require__(6);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 866:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(87);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(867);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "toolbar-general"
  }, [(_vm.transparentToolbar) ? _c('div', {
    staticClass: "opacity-div"
  }) : _vm._e(), _vm._v(" "), _c('v-app-bar', {
    staticClass: "Toolbar white px-0",
    attrs: {
      "id": "toolbar",
      "app": ""
    }
  }, [(_vm.dialMenu) ? _c('div', {
    staticClass: "transparent-div"
  }) : _vm._e(), _vm._v(" "), _c('v-speed-dial', {
    staticClass: "speed-dial",
    attrs: {
      "direction": "bottom",
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c('v-btn', {
          class: ("ma-0 my-3 " + (_vm.dialMenu ? 'dial-menu-btn-active' : '')),
          attrs: {
            "color": "black",
            "small": "",
            "fab": "",
            "text": "",
            "id": "btnDialMenu"
          },
          on: {
            "click": function($event) {
              return _vm.toggleMenu(_vm.dialMenu)
            }
          },
          model: {
            value: (_vm.dialMenu),
            callback: function($$v) {
              _vm.dialMenu = $$v
            },
            expression: "dialMenu"
          }
        }, [(_vm.dialMenu) ? _c('v-icon', [_vm._v("close")]) : _c('v-icon', [_vm._v("menu")])], 1)]
      },
      proxy: true
    }], null, false, 1483797131),
    model: {
      value: (_vm.dialMenu),
      callback: function($$v) {
        _vm.dialMenu = $$v
      },
      expression: "dialMenu"
    }
  }, [_vm._v(" "), (_vm.isUserAuthToCrud) ? _c('v-row', {
    staticClass: "mt-1 speed-dial-elem-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center"
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "fab": "",
      "small": "",
      "activeClass": "menuLink"
    },
    on: {
      "click": _vm.clickOrganizationHomeBtn
    }
  }, [_c('v-icon', [_vm._v("dashboard")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('div', {
    staticClass: "px-4 py-3 speed-dialog-label-div",
    on: {
      "click": _vm.clickOrganizationHomeBtn
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.dashboard')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isUserAuthToReports) ? _c('v-row', {
    staticClass: "mt-1 speed-dial-elem-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center"
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "fab": "",
      "small": "",
      "activeClass": "menuLink"
    },
    on: {
      "click": _vm.clickReportsBtn
    }
  }, [_c('v-icon', [_vm._v("analytics")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('div', {
    staticClass: "px-4 py-3 speed-dialog-label-div",
    on: {
      "click": _vm.clickReportsBtn
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.reports')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isUserAuthToAudits) ? _c('v-row', {
    staticClass: "mt-1 speed-dial-elem-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "align-self-center"
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "fab": "",
      "small": "",
      "activeClass": "menuLink"
    },
    on: {
      "click": _vm.clickAuditsBtn
    }
  }, [_c('v-icon', [_vm._v("mdi-clipboard-check-outline")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('div', {
    staticClass: "px-4 py-3 speed-dialog-label-div",
    on: {
      "click": _vm.clickAuditsBtn
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.audits')))])])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-avatar', {
    attrs: {
      "size": "40"
    }
  }, [_c('img', {
    staticClass: "fill-height",
    attrs: {
      "src": __webpack_require__(682),
      "alt": _vm.$t('Toolbar.profilePic')
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('ImpersonateBtn'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "BtnAccount ma-0 my-3",
          attrs: {
            "small": "",
            "fab": "",
            "text": ""
          },
          model: {
            value: (_vm.dialMenu),
            callback: function($$v) {
              _vm.dialMenu = $$v
            },
            expression: "dialMenu"
          }
        }, on), [_c('v-avatar', {
          attrs: {
            "size": "40"
          }
        }, [_c('img', {
          staticClass: "profile-img",
          attrs: {
            "src": _vm.userProfilePic
          }
        })])], 1)]
      }
    }], null, false, 1235310641)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.onLogout()
      }
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Toolbar.logout')))])], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.canImpersonate) ? _c('div', {
    staticClass: "mr-8"
  }, [(!_vm.textFieldActive) ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.activateImpersonate
    }
  }, [_vm._v(_vm._s(_vm.$t('Toolbar.virtualAccess')))]) : _vm._e(), _vm._v(" "), (_vm.textFieldActive) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.items,
      "item-text": "label",
      "item-value": "id",
      "text": "",
      "clearable": "",
      "hide-no-data": "",
      "hide-details": "",
      "label": "Usuario",
      "solo-inverted": ""
    },
    on: {
      "blur": function($event) {
        _vm.textFieldActive = false
      }
    },
    model: {
      value: (_vm.userSelected),
      callback: function($$v) {
        _vm.userSelected = $$v
      },
      expression: "userSelected"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.96a89109477167a000b5.js